import { useEffect } from "react";
import { useConsent } from "@/components/ConsentContext";

const LIVE_HOSTS = new Set(["tts-britz.de", "www.tts-britz.de"]);

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default function GoogleTagManagerConsent() {
  const { consent } = useConsent();

  useEffect(() => {
    if (!LIVE_HOSTS.has(window.location.hostname)) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer?.push(arguments);
    };

    const analyticsAllowed = consent?.statistics === true;
    const marketingAllowed = consent?.marketing === true;

    window.gtag("consent", "update", {
      analytics_storage: analyticsAllowed ? "granted" : "denied",
      ad_storage: marketingAllowed ? "granted" : "denied",
      ad_user_data: marketingAllowed ? "granted" : "denied",
      ad_personalization: marketingAllowed ? "granted" : "denied",
    });

    window.dataLayer.push({
      event: "tts_consent_update",
      consent_statistics: analyticsAllowed,
      consent_marketing: marketingAllowed,
      consent_personalized_advertising: marketingAllowed,
    });
  }, [consent]);

  return null;
}
